export default "__VITE_ASSET__CQTjet3n__"